import template from "./font-size-selector.html";

const FontSizeSelectorComponent = {
  bindings: {
    defaultValue: "<",
    onChange: "&",
  },
  template: template,
  controller: class FontSizeSelectorController {
    $onInit() {
      this.sizes = [11, 12, 13, 15, 18, 20, 24, 32, 40, 48, 53, 78, 96, 128];

      this.size = Number(this.defaultValue) || 15;
    }

    $onChanges(changesObj) {
      if (!changesObj.defaultValue.isFirstChange()) {
        const changeValue = Number(this.defaultValue) || 15;
        if (!angular.equals(this.size, changeValue)) this.size = changeValue;
      }
    }

    change() {
      if (this.size && this.size % 1 !== 0) this.form.fontSize.$invalid = true;
      else if (this.form.$valid) this.onChange({ size: this.size + "" });
    }

    changeFromTypeahead(size) {
      this.onChange({ size: size + "" });
    }
  },
};

export default FontSizeSelectorComponent;
